module.exports = __webpack_public_path__ + "static/img/1-1Z530093256159.b14c1e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z530093256159.jpg
// module id = C6Eo
// module chunks = 0